const RETRY_DELAYS_MS = [100, 300, 900, 2000],
      MAX_JITTER_MS   = 100,
      sleep = (ms) => (
	      new Promise((resolve) => {
		      setTimeout(resolve, ms);
	      })
      ),
      
      /**
       * @param {string} [url]
       * @returns {Promise<string>} token, or `''` when every attempt fails.
       */
      fetchCsrfToken = async (url = 'get-csrf-token/') => {
	      for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt++) {
		      try {
			      const response = await fetch(url); // eslint-disable-line no-await-in-loop
			      
			      if (response.ok) {
				      const body = await response.json(); // eslint-disable-line no-await-in-loop
				      
				      if (body?._csrf) {
					      return body._csrf;
				      }
			      }
		      } catch {
			      // fall through to retry
		      }
		      
		      const delay = RETRY_DELAYS_MS[attempt];
		      
		      if (delay === undefined) {
			      break;
		      }
		      
		      await sleep(delay + (Math.random() * MAX_JITTER_MS)); // eslint-disable-line no-await-in-loop
	      }
	      
	      // Exhausted retry budget — leave a breadcrumb so the blank token isn't invisible to ops.
	      console.warn(`csrfTokenFetcher: failed to obtain token from ${url} after ${RETRY_DELAYS_MS.length + 1} attempts`);
	      
	      return '';
      };

export default fetchCsrfToken;